import { createFileRoute, redirect } from "@tanstack/react-router";
import { SETTINGS_REDIRECTS } from "@/features/settings/sections";

/** Old URL (ALP-84 P4): Flags & tags is now the Tags & AI categories section of Settings → AI & knowledge. */
export const Route = createFileRoute("/_app/settings/tags")({
  beforeLoad: () => {
    throw redirect({ ...SETTINGS_REDIRECTS["/settings/tags"], replace: true });
  },
});
